module.exports = __webpack_public_path__ + "img/Screen_Shot_6.d5bff73a.png";